import { create } from "zustand";
import * as pc from "playcanvas";

interface ModelViewerState {
  resetPositionRotationEvent: number;
  triggerResetPositionRotationEvent: () => void;

  resetOnlyRotationEvent: number;
  triggerResetOnlyRotationEvent: () => void;

  positionJoystickData: number[];
  setPositionJoystickData: (value: number[]) => void;
  rotationJoystickData: number[];
  setRotationJoystickData: (value: number[]) => void;

  isModelLoaded: boolean;
  setIsModelLoaded: (value: boolean) => void;

  errorMessage: string;
  setErrorMessage: (value: string) => void;
}

export const useModelViewerStore = create<ModelViewerState>()((set, get) => ({
  resetPositionRotationEvent: 0,
  triggerResetPositionRotationEvent: () => {
    set({ resetPositionRotationEvent: Date.now() });
  },

  resetOnlyRotationEvent: 0,
  triggerResetOnlyRotationEvent: () => {
    set({ resetOnlyRotationEvent: Date.now() });
  },

  positionJoystickData: [0, 0],
  setPositionJoystickData: (value: number[]) => {
    set({ positionJoystickData: value });
  },
  rotationJoystickData: [0, 0],
  setRotationJoystickData: (value: number[]) => {
    set({ rotationJoystickData: value });
  },

  isModelLoaded: false,
  setIsModelLoaded: (value: boolean) => {
    set({ isModelLoaded: value })
  },

  errorMessage: "",
  setErrorMessage: (value: string) => {
    set({ errorMessage: value })
  },
}));
